import React from "react"
// react library for routing
import { Link } from "react-router-dom"
// reactstrap components
import {
  NavbarBrand,
  Navbar,
  Container,
  Nav,
  NavItem,
  NavLink,
  Button,
} from "reactstrap"

class AuthNavbar extends React.Component {
  render() {
    return (
      <>
        <Navbar
          className="navbar-horizontal navbar-main navbar-dark navbar-transparent"
          expand="lg"
          id="navbar-main"
        >
          <Container>
            <NavbarBrand to="/" tag={Link}>
              <img
                alt="..."
                src={require("assets/img/brand/faver-white.png")}
              />
            </NavbarBrand>
            <Nav className="align-items-lg-center ml-lg-auto" navbar>
              <NavItem>
                <NavLink to="/a/login" tag={Link}>
                  <span className="nav-link-inner--text text-white">Login</span>
                </NavLink>
              </NavItem>
              <NavItem className="d-lg-block ">
                <NavLink to="/a/register" tag={Link}>
                  <Button
                    className="btn-neutral btn-icon"
                    color="white"
                    outline
                    href=""
                    target="_blank"
                  >
                    <span className="nav-link-inner--text text-white">
                      Sign Up
                    </span>
                  </Button>
                </NavLink>
              </NavItem>
            </Nav>
          </Container>
        </Navbar>
      </>
    )
  }
}

export default AuthNavbar
